import { onBeforeUnmount, ref, shallowRef, watch } from 'vue';

import { SUPPORTS_INTERSECTION } from '@components/utils';

export function useIntersectionObserver(callback?: IntersectionObserverCallback, options?: IntersectionObserverInit) {
  const intersectionRef = ref<HTMLElement>();
  const isIntersection = shallowRef(false);

  if (SUPPORTS_INTERSECTION) {
    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      callback?.(entries, observer);

      isIntersection.value = !!entries.find((entry) => entry.isIntersecting);
    }, options);

    onBeforeUnmount(() => {
      observer.disconnect();
    });

    watch(
      intersectionRef,
      (newValue, oldValue) => {
        if (oldValue) {
          observer.unobserve(oldValue);
          isIntersection.value = false;
        }

        if (newValue) observer.observe(newValue);
      },
      {
        flush: 'post'
      }
    );
  }

  return { intersectionRef, isIntersection };
}
